import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "table-wrap"
};
const _hoisted_2 = {
  class: "audit-card"
};
const _hoisted_3 = {
  style: {
    "width": "30%",
    "text-align": "left",
    "font-weight": "bold"
  }
};
const _hoisted_4 = {
  style: {
    "width": "50%",
    "text-align": "center"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = {
  style: {
    "flex": "1",
    "word-break": "break-all",
    "word-wrap": "break-word"
  }
};
const _hoisted_7 = {
  key: 0,
  class: "state waiting"
};
const _hoisted_8 = {
  key: 1,
  class: "state loading"
};
const _hoisted_9 = {
  key: 2,
  class: "state success"
};
const _hoisted_10 = {
  key: 3,
  class: "state break"
};
const _hoisted_11 = {
  class: "el-pagination-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_form = _resolveComponent("el-form");
  const _component_audit_state = _resolveComponent("audit-state");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": true,
    title: "关联的短信需求",
    width: "1050px",
    "model-value": $props.visible,
    "show-close": true,
    onClose: $setup.close,
    center: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
      height: "450",
      data: _ctx.tableData,
      "row-class-name": $setup.tableRowClassName
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        type: "expand"
      }, {
        default: _withCtx(props => [_createVNode(_component_el_form, {
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求名称:"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(props.row.demandName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_form_item, {
            label: "短信有效期:"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(props.row.bgnDate) + " ~ " + _toDisplayString(props.row.bgnDate), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_form_item, {
            label: "短信内容:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              readonly: "",
              type: "textarea",
              rows: 3,
              modelValue: props.row.content,
              "onUpdate:modelValue": $event => props.row.content = $event,
              maxlength: "200",
              "show-word-limit": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024), _createVNode(_component_el_form_item, {
            label: "关联产品offerId:"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.offerIds.split(','), offerId => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: offerId,
                class: "mx-1",
                "disable-transitions": false
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(offerId), 1)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.approveInfos, appr => {
            return _openBlock(), _createBlock(_component_el_col, {
              span: 12,
              key: appr.roleId
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
                style: {
                  "height": "22px"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(appr.roleName) + " | " + _toDisplayString(_ctx.auditTip[appr.approveState + 1]) + " ", 1), _createVNode(_component_audit_state, {
                  state: appr.approveState
                }, null, 8, ["state"])]), _createElementVNode("div", _hoisted_4, _toDisplayString(appr.approveTime), 1)]),
                _: 2
              }, 1024), props.row.state != -1 && appr.approveState == 0 ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 暂未审核 ", -1)]))]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_row, {
                key: 1
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("div", {
                  style: {
                    "width": "80px"
                  }
                }, "审核意见：", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(appr.aprroveContent), 1)])]),
                _: 2
              }, 1024))])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "demandName",
        label: "需求名称",
        "min-width": "18%"
      }), _createVNode(_component_el_table_column, {
        prop: "createrName",
        label: "需求人",
        "min-width": "8%"
      }), _createVNode(_component_el_table_column, {
        prop: "state",
        label: "状态",
        "min-width": "8%"
      }, {
        default: _withCtx(scope => [scope.row.state == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "state-tag waiting"
        }, null, -1), _createTextVNode(" 待审核 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "state-tag loading"
        }, null, -1), _createTextVNode(" 待入库 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "state-tag success"
        }, null, -1), _createTextVNode(" 已入库 ", -1)]))])) : _createCommentVNode("", true), scope.row.state == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "state-tag break"
        }, null, -1), _createTextVNode(" 挂起 ", -1)]))])) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data", "row-class-name"])), [[_directive_loading, _ctx.loading]])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_pagination, {
      onSizeChange: $setup.handleSizeChange,
      onCurrentChange: $setup.handleCurrentChange,
      "page-sizes": [5, 10, 20, 30, 40],
      "page-size": _ctx.paginationObj.size,
      total: _ctx.paginationObj.total,
      currentPage: _ctx.paginationObj.current,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _ctx.paginationObj.current = $event),
      layout: "prev, pager, next, sizes, jumper"
    }, null, 8, ["onSizeChange", "onCurrentChange", "page-size", "total", "currentPage"])])]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}